import { CloudFileStatus } from "../../../../common/types/CloudFileStatus";
import { CloudFileDetails } from "../../../CloudFileDetails";

export const shouldDisableCloudFileEdit = (details: CloudFileDetails): boolean =>
    ![CloudFileStatus.InQc, CloudFileStatus.WaitingForClientResponse].includes(details.status);
